import styled from "@emotion/styled";
import { theme, Modal } from "@xometry/xometry_loft";

export const StyledModal = styled(Modal)`
  min-width: 350px;
  max-width: 500px !important;
  padding: ${theme.space[6]};
  border-radius: ${theme.borders[2]};
  overflow-y: auto;
  box-sizing: border-box;

  .modal-title {
    padding-bottom: ${theme.space[4]};
    position: relative;

    label {
      font-size: ${theme.fontSizes[0]};
      line-height: ${theme.lineHeights[2]};
    }
    legend {
      font-size: ${theme.fontSizes[3]};
      font-weight: ${theme.fontWeights.semibold};
      line-height: ${theme.lineHeights[4]};
      padding-right: ${theme.space[6]};
      padding-bottom: ${theme.space[3]};
    }
    button {
      font-size: ${theme.fontSizes[3]};
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .modal-title__description {
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.lineHeights[3]};
    color: ${theme.colors.darkBlues[75]};
  }
  .submission-modal__submit-button {
    margin-left: ${theme.space[3]};
  }

  .expiresField {
    margin: ${theme.space[2]} 0 ${theme.space[5]};
    .expiresAfterDays--select {
      width: 50%;
    }
    .expiresAfterDays--description {
      margin-top: ${theme.space[1]};
    }
    .expiresTooltip {
      display: inline-block;
      color: ${theme.colors.blues[100]};
      padding-left: ${theme.space[1]};
      .expiresTooltip--content {
        min-width: 240px;
      }
    }
  }

  .recipientField {
    margin-bottom: ${theme.space[5]};
  }
`;

export const FormWrapper = styled.div`
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }

  legend {
    font-size: ${theme.fontSizes[3]};
    line-height: ${theme.lineHeights[4]};
  }

  .field-description {
    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
    color: ${theme.colors.darkBlues[75]};
    font-size: ${theme.fontSizes[0]};
    margin-block-start: 0em;
    margin-bottom: 1.2rem;
    padding-bottom: 1.2rem;
  }

  label {
    display: block;
    font-size: ${theme.fontSizes[0]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights[1]};
    margin-bottom: ${theme.space[1]};
  }

  .error-detail.bs-callout.bs-callout-info,
  label.control-label {
    display: none;
  }

  input {
    width: 100%;
  }

  textarea {
    width: calc(100% - ${theme.space[5]});
  }
  .meta-section-header {
    border-bottom: ${theme.borders[0]} solid ${theme.colors.darkBlues[10]};
    margin-bottom: ${theme.space[4]};
    padding-bottom: ${theme.space[2]};
  }

  .with-tooltip-title,
  .box p {
    white-space: pre-wrap;
    line-height: ${theme.lineHeights[3]};
    font-size: ${theme.fontSizes[1]};
    margin-bottom: ${theme.space[1]};
  }
  .box {
    vertical-align: top;
    margin-bottom: ${theme.space[4]};
  }
`;
